const stripHighlightMarkers = (value: string): string =>
	value.replace(/@@@hl@@@/g, '').replace(/@@@endhl@@@/g, '');

type getLabelArgs = {
	label: string;
	firstSelectedLabel: string;
	numSelectedOptions: number;
};

export const getButtonText = ({
	label,
	firstSelectedLabel = '',
	numSelectedOptions,
}: getLabelArgs): string => {
	const sanitizedFirstSelectedLabel = stripHighlightMarkers(firstSelectedLabel);
	const colon = sanitizedFirstSelectedLabel && label ? ': ' : '';
	const comma = sanitizedFirstSelectedLabel && numSelectedOptions > 1 ? ',' : '';

	return `${label}${colon}${sanitizedFirstSelectedLabel}${comma}`;
};
